import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
/* import MUIDataTable from "../MUIDataTable/MUIDataTable"; */
import MUIDataTable from "mui-datatables";
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Slide, Dialog, Button } from '@mui/material';
// import PropTypes from 'prop-types'
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import IconButton from '@mui/material/IconButton';
import ReclamosDetails from './TramitesDetails';
import { findTramites, searchTramites, seguirTramite, dejarDeSeguirTramite } from "../../service/service.supersalud";
import Spinner from '../templates/Spinner'
import Image from "react-bootstrap/Image";
import logo from "./../../images/logo.png";
import TramitesDetails from './TramitesDetailsMovil';
import ListraTramitesMovil from './ListaTramitesMovil';
import { validateRut } from "@fdograph/rut-utilities";
import CustomTable from '../commons/CustomTable';
import { actionsSeguimiento, getDatosReclamosList, tableHeadCellsSeguimiento, canMonitor, actionsSeguimientoNoMonitor, ordenarFechas, sinResultados } from '../commons/utils';
import DecisionModal from '../commons/DecisionModal';
import ModalSolicitudes from '../commons/ModalSolicitudes';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const options = {
    rowsPerPageOptions: [1, 5, 10, 15, 100],
    selectableRowsHeader: false,
    selectableRows: "none",
    filter: true,
    search: true,
    print: true,
    viewColumns: true,
    filterType: 'dropdown',
    responsive: 'vertical',
    download: false,
    enableNestedDataAccess: '.',
};

const optionsMobile = {
    rowsPerPageOptions: [1, 5, 10, 15, 100],
    selectableRowsHeader: false,
    selectableRows: "none",
    filter: false,
    search: false,
    print: false,
    viewColumns: false,
    filterType: 'dropdown',
    responsive: 'vertical',
    download: false,
    enableNestedDataAccess: '.',
}

const ListTramites = props => {

    const { user, userLogOut, wildcard, rut, userLoggedIn, type, searchNow } = props;
    const history = useHistory();
    const classes = useStyles();
    const [recActivo, setrecActivo] = useState([]);
    const [firstLoad, setFirstLoad] = useState(true);
    const [tramites, setTramites] = useState([])
    const [openModal, setOpenModal] = useState({ open: false });
    const [searchWild, setsearchWild] = useState(false);
    const [loading, setLoading] = useState(true);
    const { innerWidth: width/*, innerHeight: height*/ } = window;

    const [showModalDecision, setShowModalDecision] = useState(false)
    const [tramiteMonitoreo, setTramiteMonitoreo] = useState('')



    const [modalBody, setModalBody] = useState('');
    const [modalTitle, setModalTitle] = useState('');
    const [modalAccept, setModalAccept] = useState('');
    const [modalCancel, setModalCancel] = useState('');
    const [hideModalFields, setHideModalFields] = useState(false)

    const [solActiva, setSolActiva] = useState('')
    const [showModalSolicitudes, setShowModalSolicitudes] = useState(false)

    const submitDecisionModal = (tramite) => {
        if (tramite.monitoreo) {
            stopFollowTramite(tramite)
        } else {
            followTramite(tramite)
        }

    }

    const openDecisionModal = (tramite) => {
        setTramiteMonitoreo(tramite)
        setShowModalDecision(true)
    }

    const closeDecisionModal = () => {
        setShowModalDecision(false)
        setTramiteMonitoreo('')

    }

    const handleClose = () => {
        setOpenModal({ open: false });
    };

    const closeModalSolicitud = () => {
        setShowModalSolicitudes(false)
        setSolActiva('')
    }

    const openModalSolicitudes = row => {
        if(row.ux==='atencion_usuarios'){
            let aux={
                ...row,
                clasificacion:'gestion_interna'
            }
            setSolActiva(aux)
            setShowModalSolicitudes(true)
        }else if(row.ux==='gestion_externa'){
            let aux={
                ...row,
                clasificacion:'gestion_externa'
            }
            setSolActiva(aux)
            setShowModalSolicitudes(true)
        }else{
            setSolActiva(row)
            setShowModalSolicitudes(true)
        }

    }

    const logout = () => {
        userLogOut();
        history.push("/login")
    }

    const openModalMovil = item => {
        setrecActivo(item)
        setOpenModal({ open: true });

    }

    const followTramite = async (tramite) => {

        const resp = await seguirTramite(user, logout, userLoggedIn)(JSON.stringify({ indice: tramite.ux, folio: tramite.folio, reclamante: tramite.nombre_raw, etapa: tramite.etapa_actual, fecha_ingreso: tramite.fecha_ingreso, rut: tramite.run_rec, fecha_etapa: tramite.fecha_etapa, solicitud: tramite.solicitud, observaciones: tramite.observaciones, usuario_solicitante: tramite.usuario_solicitante, prioridad:tramite.prioridad }));
        if (resp.status === 201) {
            closeDecisionModal()

            let auxWildCard = { value: wildcard, type: type }
            window.gtag("event", "listar_tramite", {
                event_category: "access",
                event_label: "listado"
            });
            if (wildcard !== '') {
                getTramites(auxWildCard)
            } else {
                getTramitesByRut(user.rut)
            }

            /*    getTramitesByRut(user.rut) */
        }

    }

    const stopFollowTramite = async (tramite) => {
        const resp = await dejarDeSeguirTramite(user, logout, userLoggedIn)(JSON.stringify({ indice: tramite.ux, folio: tramite.folio }));
        if (resp.status === 204) {
            closeDecisionModal()
            let auxWildCard = { value: wildcard, type: type }
            window.gtag("event", "listar_tramite", {
                event_category: "access",
                event_label: "listado"
            });
            if (wildcard !== '') {
                getTramites(auxWildCard)
            } else {
                getTramitesByRut(user.rut)
            }
            /*  getTramitesByRut(user.rut) */
        }
    }

    const getTramitesByRut = async (rut) => {

        if (rut) {
            const resp = await findTramites(user, logout, userLoggedIn)(JSON.stringify({
                ...(rut && { rut }),
            }));
            const results = await resp.json()

            let auxArray = []
            results["results"].map((obj, index) => {

                let auxObj = {
                    ...obj,
                    etapa_actual_tabla: obj.fase.nombre
                }
                auxArray.push(auxObj)
            })

            
            setTramites(
                auxArray.map((item, index) => {
                    return getDatosReclamosList(item, true)
                })
            )
            setFirstLoad(false)
            setLoading(false)
        }

    }

    const getTramites = async (wildcard) => {
        let resp = undefined;

        if (wildcard !== '') {
            setsearchWild(true)

            resp = await searchTramites(user, logout, userLoggedIn)(JSON.stringify({
                ...(wildcard && { wildcard })
            }));
            setsearchWild(false)
        }

        const resp_status = (resp || {}).status;
        if (resp_status === 200) {
            const results = await resp.json()

            /* setTramites(results["results"]); */
            let auxArray = []
            results["results"].map((obj, index) => {

                let auxObj = {
                    ...obj,
                    etapa_actual_tabla: obj.fase.nombre
                }
                auxArray.push(auxObj)
            })

           
            setTramites(
                auxArray.map((item, index) => {
                    return getDatosReclamosList(item, true)
                })
            )
        }
        setLoading(false)

    }

    useEffect(
        () => {
            setLoading(true)
            getTramitesByRut(rut)

        }, [])

    useEffect(
        () => {
            setLoading(true)

            if (!firstLoad) {

                let auxWildCard = { value: wildcard, type: type }
                window.gtag("event", "listar_tramite", {
                    event_category: "access",
                    event_label: "listado"
                });
                if (user === null) {
                    return history.push("/");
                } else {

                    if (wildcard !== '') {
                        getTramites(auxWildCard)
                    } else {
                        getTramitesByRut(rut)
                    }

                }
            } else {
                setFirstLoad(false)
                setLoading(false)
            }


        }, [wildcard, searchNow]
    );

    const dataIsInArray = (data, array, index) => {

        let aux = false

        if (index === 0) {

        } else {
            array.map((item, indice) => {
                if(item===data){
                    aux=true
                }
                return null
            })
        }

        return aux

    }

    const getTramitaciones = () => {/* hacer metodo para que deje solo 1 de cada 1 */
        let aux = []
        tramites.map((item, index) => {
           
            if(!dataIsInArray(item.tramitacion,aux,index)){
                aux.push(item.tramitacion)   
            }
            return null
        })
        return aux
    }

    const getReclamados = () => {/* hacer metodo para que deje solo 1 de cada 1 */
        let aux = []
        tramites.map((item, index) => {
            if(!dataIsInArray(item.reclamado,aux,index)){
                aux.push(item.reclamado)
            }
            return null
        })
        return aux
    }

    const getEtapas = () => {
        let aux = []
        tramites.map((item,index)=>{
          
            if(!dataIsInArray(item.etapa_actual,aux,index)){
                aux.push(item.etapa_actual)
            }
            return null
        })

        return aux
    }

    const validaciones = [
        {
            type: 'dateRange',
            target: 'fechaIngreso',
            title: 'Fecha',
        },
        {
            type: 'select',
            target: 'tramitacion',
            title: 'Tipo Trámite',
            options: getTramitaciones()
        },
        {
            type: 'select',
            target: 'reclamado',
            title: 'Entidad',
            options: getReclamados()
        },
        {
            type: 'select',
            target: 'etapa_actual',
            title: 'Etapa',
            options: getEtapas()
        },
    ];

    const handleAction = (menu, item) => {

        if (menu.action === 'verDetalle') {
            if(item.ux==='atencion_usuarios' || item.ux==='gestion_externa'){
                openModalSolicitudes(item)
            }else{
                openModalHandler(item)
            }
/*             setrecActivo(item)
            setOpenModal({ open: true }); */

        } else if (menu.action === 'dejar_seguir') {
            setModalBody('¿Desea dejar de monitorear éste trámite?')
            setModalTitle('Monitorear trámite')
            setModalAccept('Dejar de monitorear')
            setModalCancel('Cancelar')
            setHideModalFields(true)
            openDecisionModal(item)

        } else if (menu.action === 'monitorear') {
            setModalBody('¿Desea monitorear éste trámite?')
            setModalTitle('Monitorear trámite')
            setModalAccept('Monitorear')
            setModalCancel('Cancelar')
            setHideModalFields(false)
            openDecisionModal(item)
        }
    };

    const openModalHandler = fila => {
        setrecActivo(fila)
        setOpenModal({ open: true });
    };

    return (
        <Fragment>
            <DecisionModal
                title={modalTitle}
                body={modalBody}
                accept={modalAccept}
                cancel={modalCancel}
                closeModal={closeDecisionModal}
                submitModal={submitDecisionModal}
                openDialog={showModalDecision}
                tramite={tramiteMonitoreo}
                hideFields={hideModalFields}
            />
            <Grid
                container
                direction="row"
                justifyContent="center"

                alignItems="center"

            >
                {loading ? <Spinner /> : null}
                {
                    tramites && tramites.length > 0 ?
                        width > 500 ?
                            < Grid className={classes.section}  >



                                { /*                                             <MUIDataTable
                                                                                    data={tramites}
                                                                                    columns={columns}
                                                                                    options={options}
                                    
                                                                                /> */}
                                <CustomTable
                                    headCells={tableHeadCellsSeguimiento}
                                    rows={tramites}
                                    /* title={'Seguimiento de trámites'} */
                                    /* validation={validaciones} */
                                    search={true}
                                    /*      filter= {true}
                                         print ={true} */
                                    validation={validaciones}
                                    /* viewColumns ={true} */
                                    // actions={actionsSeguimiento}
                                    actions= { canMonitor(user) ? actionsSeguimiento: actionsSeguimientoNoMonitor}
                                    handleAction={handleAction}
                                    openModal={openModalHandler}
                                    openModalSolicitudes={openModalSolicitudes}
                                />



                            </Grid>
                            :
                            < Grid style={{ width: '100%' }} className={classes.section}  >


                                <ListraTramitesMovil
                                    data={tramites}
                                    openModalMovil={openModalMovil}
                                    user={user}
                                    openDecisionModal={openDecisionModal}
                                    setModalBody={setModalBody}
                                    setModalTitle={setModalTitle}
                                    setModalAccept={setModalAccept}
                                    setModalCancel={setModalCancel}
                                    setHideModalFields={setHideModalFields}
                                    openModalSolicitud={openModalSolicitudes}

                                />

                            </Grid>

                        :
                        loading ? null:sinResultados()

                }
            </Grid>
            {
                searchWild ?
                    <Spinner />
                    :
                    null
            }
            <Dialog fullScreen open={openModal.open} onClose={handleClose} TransitionComponent={Transition}>
                <Fragment>
                    {/* <AppSuperBar />
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <Typography variant="h6" className={classes.title}>
                                Seguimiento de trámite 2{openModal && openModal.active ? `nro ${openModal.active}` : null}
                            </Typography>
                            <Button  color="inherit" onClick={handleClose} >
                            <ExitToAppOutlinedIcon style={{ transform: "rotate(-180deg)"}}/>
                                Volver
                            </Button>
                        </Toolbar>
                    </AppBar>*/}

                    <header className="d-flex header-resposive-ss">

                        <Image src={logo} className="logo-responsive" />

                        <Button color="inherit" onClick={handleClose} >
                            <ExitToAppOutlinedIcon style={{ transform: "rotate(-180deg)" }} />
                            Volver
                        </Button>

                    </header>

                    {width > 500 ?
                        /* muestra los detalles vanilla en modal */
                        <ReclamosDetails
                            {...{
                                user: user,
                                recActivo: recActivo,
                                openModal,
                                userLogOut,
                                userLoggedIn
                            }} />
                        :
                        /* muestra los detalles en version telefono movil en modal */
                        <TramitesDetails
                            {...{
                                user: user,
                                recActivo: recActivo,
                                openModal,
                                userLogOut,
                                userLoggedIn
                            }}
                        />
                    }
                </Fragment>
            </Dialog>
            <Dialog fullScreen open={showModalSolicitudes} onClose={closeModalSolicitud} TransitionComponent={Transition}>
                <Fragment>
                    <header className="d-flex header-resposive-ss">
                        <Image src={logo} className="logo-responsive" />
                        <Button color="inherit" onClick={closeModalSolicitud} >
                            <ExitToAppOutlinedIcon style={{ transform: "rotate(-180deg)" }} />
                            Volver
                        </Button>
                    </header>


                    <ModalSolicitudes
                        user={user}
                        recActivo={solActiva}
                        openModal={showModalSolicitudes}
                        userLogOut={userLogOut}
                        userLoggedIn={userLoggedIn}
                    />


                </Fragment>
            </Dialog>
        </Fragment >
    );
}

export default ListTramites;

const useStyles = makeStyles((theme) => ({
    appBarTop: {
        backgroundColor: '#fff',
    },
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    section: {
        marginBottom: '5%',
        width: '100%'
    }
}));


// ListTramites.propTypes={
//     user:PropTypes.object.isRequired

// }